/* Country Road Fashions — the Shop directory.

   Behaviour is V5's, deliberately: hover opens, leaving either the trigger or
   the panel closes after a beat, focus opens, Escape closes and hands focus
   back, and the trigger's own click is never intercepted so the link still
   goes where it says it goes.

   The 150ms close delay is the whole trick. Without it the panel snaps shut in
   the gap between the trigger and the panel below it, and the menu becomes
   impossible to use with a mouse.

   No dependencies, and nothing here builds markup: the directory is rendered
   by Liquid from the staff's own menu, so it is in the page for search engines
   and for anyone whose JS never arrives. */
(function () {
  'use strict';

  var DELAY = 150;

  // Below this the directory is not a hover panel at all: it is the phone
  // drawer's accordion, permanently in flow, opened section by section by a
  // checkbox. Nothing here should touch it there -- an aria-expanded on a
  // trigger that controls nothing, or a data-open the CSS has to fight, are
  // both just noise for anyone on a phone with a screen reader.
  var DESKTOP = window.matchMedia('(min-width:861px)');

  document.querySelectorAll('[data-crf-mega]').forEach(function (root) {
    var trigger = root.querySelector('.crf-mega__trigger');
    var panel = root.querySelector('.crf-mega__panel');
    if (!trigger || !panel) return;

    var timer = null;
    var open = false;

    function show() {
      if (open || !DESKTOP.matches) return;
      clearTimeout(timer);
      panel.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      open = true;
    }

    function hide(now) {
      clearTimeout(timer);
      var run = function () {
        panel.setAttribute('data-open', 'false');
        trigger.setAttribute('aria-expanded', 'false');
        open = false;
      };
      if (now) run(); else timer = setTimeout(run, DELAY);
    }

    function sync() {
      if (DESKTOP.matches) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else {
        hide(true);
        trigger.removeAttribute('aria-expanded');
      }
    }
    sync();
    DESKTOP.addEventListener('change', sync);

    trigger.addEventListener('mouseenter', show);
    trigger.addEventListener('mouseleave', function () { hide(false); });
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', function () { hide(false); });

    // Focus opens -- but Escape closes and then hands focus back, and handing
    // focus back fires this listener, which reopened the panel a frame later.
    // V5 has the same shape and the same bug; a menu that cannot be dismissed
    // with Escape is not a menu anyone can get out of, so this guards it.
    var refocusing = false;
    trigger.addEventListener('focus', function () {
      if (refocusing) return;
      show();
    });
    // Tabbing out of the last link in the panel should close it. focusout
    // fires before the new element is focused, so the check is deferred.
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        if (open && !root.contains(document.activeElement)) hide(true);
      }, 0);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) {
        hide(true);
        refocusing = true;
        trigger.focus();
        setTimeout(function () { refocusing = false; }, 0);
      }
    });

    // The trigger navigates; closing first stops the panel hanging over the
    // page it is on its way to.
    trigger.addEventListener('click', function () { hide(true); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) hide(true);
    });

    document.addEventListener('click', function (e) {
      if (!open) return;
      if (root.contains(e.target)) return;
      hide(true);
    });
  });
}());

/* The small dropdowns (a menu item with one level of sub-items, e.g. In-Store)
   are <details>, so a tap or a keyboard opens them with no script. Where there
   is a mouse they also open on hover, like the Shop panel (Darvesh
   2026-10-01), with a short grace period so the pointer can cross to the list. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('.crf-masthead__nav details.crf-masthead__menu').forEach(function (menu) {
    var timer;
    menu.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      document.querySelectorAll('.crf-masthead__nav details.crf-masthead__menu[open]').forEach(function (other) {
        if (other !== menu) other.removeAttribute('open');
      });
      menu.setAttribute('open', '');
    });
    menu.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { menu.removeAttribute('open'); }, 220);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.crf-masthead__nav details.crf-masthead__menu[open]').forEach(function (m) {
      m.removeAttribute('open');
      var s = m.querySelector('summary'); if (s) s.focus();
    });
  });
}());

/* The phone menu's accordion (Darvesh 2026-10-07: "for shop… it can
   collapse, it can open. Even for in-store"). Below 861px a heading opens
   its list instead of leaving the page; opening one closes the other, so the
   menu always fits one screen. Above that, the heading is a link as before. */
(function () {
  var PHONE = window.matchMedia('(max-width:860px)');
  var roots = document.querySelectorAll('.crf-masthead__nav [data-crf-mega]');
  roots.forEach(function (root) {
    var trigger = root.querySelector('.crf-mega__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      if (!PHONE.matches) return;
      e.preventDefault();
      var opening = !root.classList.contains('is-open');
      roots.forEach(function (other) {
        other.classList.remove('is-open');
        var t = other.querySelector('.crf-mega__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (opening) {
        root.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}());
